import React from "react";

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  hint?: string;
};

export default function Field({ label, leftIcon, rightIcon, hint, ...rest }: Props) {
  return (
    <label className="block">
      {label && (
  <span className="block text-sm font-semibold text-[#111] mb-1">
    {label}
  </span>
)}
      <div className="relative">
        {/* {leftIcon && <span className="absolute inset-y-0 left-3 grid place-items-center text-black/50">{leftIcon}</span>} */}
        {leftIcon && (
  <span className="absolute left-3 top-1/2 -translate-y-1/2 text-black/50 flex items-center justify-center h-5 w-5">
    {leftIcon}
  </span>
)}
        <input
          {...rest}
          className={[
            "w-full h-[40px] rounded-lg border",
            "border-black/15 focus:border-black/30 outline-none",
            "bg-white/95 shadow-[0_1px_0_rgba(0,0,0,0.02)_inset]",
            leftIcon ? "pl-9 pr-9" : "px-3",
            rightIcon ? "pr-9" : "",
            "text-[13.5px]",
          ].join(" ")}
          id={label.toLowerCase().replace(/\s+/g, "-")}
          autoComplete="off"
        />
        {/* {rightIcon && <span className="absolute inset-y-0 right-3 grid place-items-center text-black/50">{rightIcon}</span>} */}
          {rightIcon && (
  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-black/50 flex items-center justify-center h-5 w-5">
    {rightIcon}
  </span>
)}
      </div>
      {hint && <span className="mt-1 block text-[11px] text-red-500">{hint}</span>}
    </label>
  );
}
